module.exports = function getResource(label, vars = []) {
    const resources = {
        continueToCheckoutButton: 'Passer à la caisse',
        checkoutWithApplePayButton: 'Payer avec Apple Pay',
        applePayButton: 'Apple Pay',
        checkoutButton: 'Passer à la caisse'
    };

    return resources[label];
};
